/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetShadowMCPInventoryServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetShadowMCPInventoryServerRequest = {
  projectId: string;
  /**
   * Shadow MCP server slug to inspect.
   */
  serverSlug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetShadowMCPInventoryServerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetShadowMCPInventoryServerSecurity$outboundSchema: z.ZodMiniType<
  GetShadowMCPInventoryServerSecurity$Outbound,
  GetShadowMCPInventoryServerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getShadowMCPInventoryServerSecurityToJSON(
  getShadowMCPInventoryServerSecurity: GetShadowMCPInventoryServerSecurity,
): string {
  return JSON.stringify(
    GetShadowMCPInventoryServerSecurity$outboundSchema.parse(
      getShadowMCPInventoryServerSecurity,
    ),
  );
}

/** @internal */
export type GetShadowMCPInventoryServerRequest$Outbound = {
  project_id: string;
  server_slug: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetShadowMCPInventoryServerRequest$outboundSchema: z.ZodMiniType<
  GetShadowMCPInventoryServerRequest$Outbound,
  GetShadowMCPInventoryServerRequest
> = z.pipe(
  z.object({
    projectId: z.string(),
    serverSlug: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      serverSlug: "server_slug",
      gramSession: "Gram-Session",
    });
  }),
);

export function getShadowMCPInventoryServerRequestToJSON(
  getShadowMCPInventoryServerRequest: GetShadowMCPInventoryServerRequest,
): string {
  return JSON.stringify(
    GetShadowMCPInventoryServerRequest$outboundSchema.parse(
      getShadowMCPInventoryServerRequest,
    ),
  );
}
